import cx from 'classnames';

import { Box, BoxProps } from '@/components/Elements';
import { usePlatform } from '@/hooks/usePlatform';

import * as styles from './Badge.css';

export interface BadgeProps extends BoxProps {
  count: number;
}

export const Badge = ({ count, className }: BadgeProps) => {
  const { isIOS, isAndroid, isWeb } = usePlatform();

  return (
    <Box
      component="span"
      className={cx({
        [styles.badge['ios']]: isIOS,
        [styles.badge['android']]: isAndroid || isWeb,
        [className as string]: !!className,
      })}
    >
      {count}
    </Box>
  );
};
